<template>
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M21.75 5.25H2.25a1.5 1.5 0 0 0-1.5 1.5v15a1.5 1.5 0 0 0 1.5 1.5h19.5a1.5 1.5 0 0 0 1.5-1.5v-15a1.5 1.5 0 0 0-1.5-1.5Z"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      clip-rule="evenodd"
      d="M4 17.76V10.7a1.48 1.48 0 0 1 1.23-1.47A37.53 37.53 0 0 1 12 8.75a37.531 37.531 0 0 1 6.77.48A1.48 1.48 0 0 1 20 10.7v7.06a1.49 1.49 0 0 1-1.26 1.48c-2.228.36-4.483.53-6.74.51-2.257.02-4.512-.15-6.74-.51A1.49 1.49 0 0 1 4 17.76Z"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="m10.5.75 3.75 4.5L18 .75"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
